import React, { useState, useEffect } from "react";
import { TargetEvent } from "../../constants/enums";

export interface TableCell {
    value: string | JSX.Element
    cssClass?: string
    customWidth?: number
    customHeight?: number
}
export interface TableRowProps {
    tableCells: Array<TableCell>
    extraContent?: JSX.Element,
    dropdownInUse?: boolean,
    rowId?: string,
    buttonPressed?: boolean,
    rowNumber?: number,
    rowClass?: string,
    areAllRowsExpanded?: boolean
}

export const TableRow = ({
    ...props
}: TableRowProps) => {
    const [displayExtra, setDisplay] = useState<boolean>(false);
    const [expanded, setExpanded] = useState<string>("");

    const [tableRowHeight, setTableRowHeight] = useState<number>(0);
    const [extraTableRowHeight, setExtraTableRowHeight] = useState<number>(0);

    useEffect(() => {
        setDisplay(props.areAllRowsExpanded || false);
        setExpanded(props.areAllRowsExpanded ? "expanded" : "");

    }, [props.areAllRowsExpanded]);

    function displayExtraContent() {
        if (props.extraContent == null) {
            setDisplay(false);
        } else {
            setDisplay(!displayExtra);
            if (!displayExtra) {
                setExpanded("expanded");
            } else {
                setExpanded("");
            }
        }
    }

    const handleEnterPress = (event: any) => {
        if (event.key === TargetEvent.Enter) {
            displayExtraContent();
        }
    }

    const arrowUp = (
        <React.Fragment>
            <td tabIndex={0} className="table-dropdown-container" onKeyPress={handleEnterPress} onClick={() => displayExtraContent()}>
                <span className="table-row-separator table-span"></span>
                <span className="material-icons chev animate-arrow table-span" aria-label="keyboard_arrow_up">
                    keyboard_arrow_up
                </span>
            </td>
        </React.Fragment>
    )

    const arrowDown = (
        <React.Fragment>
            <td tabIndex={0} className="table-dropdown-container" onKeyPress={handleEnterPress} onClick={() => displayExtraContent()}>
                <span className="table-row-separator table-span"></span>
                <span className="material-icons chev animate-arrow selected table-span" aria-label="keyboard_arrow_down">
                    keyboard_arrow_up
                </span>
            </td>
        </React.Fragment>
    )

    const getArrow = (display: boolean) => {
        if (display) {
            return arrowUp;
        } else {
            return arrowDown;
        }
    }

    const tableCells = props.tableCells.map((tableCell, i) => {
        if (tableCell.cssClass === undefined) {
            tableCell.cssClass = "";
        }

        return <React.Fragment key={`product-info-cell-${i}`}>
            {tableCell.customHeight ?
                <td className={tableCell.cssClass + " justify-content"} style={{ height: `${tableRowHeight}px` }}>
                    {tableCell.value}
                </td>
                :
                <td className={tableCell.cssClass + " justify-content"} >
                    {tableCell.value}
                </td>
            }
        </React.Fragment>
    });

    if (!props.extraContent && props.dropdownInUse) {
        tableCells.push(<td className="dropdownInUse-content" key={"dropdownInUse-content"}></td>)
    }

    if (props.rowId) {
        let height: number = 47;
        var tblRw = document.getElementById(`${props.rowId}-${props.rowNumber}`);
        if (tblRw) {
            height = tblRw.offsetHeight;
        }

        useEffect(() => {
            setTableRowHeight(height);
        }, [height]);

        let extraRowHeight: number;

        useEffect(() => {
            var extraContentRw = document.getElementById(`${props.rowId}-extra-content-${props.rowNumber}`);
            if (extraContentRw) {
                extraRowHeight = extraContentRw.offsetHeight;
            }
            if (displayExtra && extraRowHeight !== extraTableRowHeight) {
                setExtraTableRowHeight(extraRowHeight);
            }
        }, [displayExtra]);
    }

    let zIndex: number = 1;
    if (displayExtra && props.buttonPressed) {
        var extraContentRw = document.getElementById(`${props.rowId}-extra-content-${props.rowNumber}`);
        if (extraContentRw) {
            if (extraContentRw.querySelector(".display-list") !== null) {
                zIndex = 2;
            } else {
                zIndex = 1;
            }
        }
    }

    return (
        <React.Fragment>
            <tr className={`table-row-content ${expanded} ${props.rowClass}`} id={`${props.rowId}-${props.rowNumber}`}>
                {tableCells}
                {props.extraContent ?
                    getArrow(displayExtra) : null
                }
            </tr>
            {displayExtra ?
                <tr className={`table-row-content ${expanded}-content-border`}>
                    <td colSpan={tableCells.length + 1}></td>
                </tr> : null
            }
            {displayExtra ?
                <tr className={`table-row-content ${expanded}-content`} style={{ height: `${extraTableRowHeight}px` }}>
                    <td colSpan={tableCells.length + 1} className="extra-content-fix" id={`${props.rowId}-extra-content-${props.rowNumber}`} style={{ zIndex: `${zIndex}` }}>
                        {props.extraContent}
                    </td>
                </tr> : null
            }
        </React.Fragment>
    );
};
